import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

const PropertyContext = createContext(null);

export function PropertyProvider({ children }) {
  const { user } = useAuth();
  const [properties, setProperties] = useState([]);
  const [propertyId, setPropertyId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) { setLoading(false); return; }
    (async () => {
      try {
        const { data } = await api.get("/properties");
        setProperties(data.items || []);
        const saved = localStorage.getItem("pp_property_id");
        const first = data.items?.[0]?.id;
        const initial = saved && data.items.find(p => p.id === saved) ? saved : first;
        setPropertyId(initial);
      } finally {
        setLoading(false);
      }
    })();
  }, [user]);

  const selectProperty = (id) => {
    setPropertyId(id);
    localStorage.setItem("pp_property_id", id);
  };

  const currentProperty = properties.find(p => p.id === propertyId) || null;

  return (
    <PropertyContext.Provider value={{ properties, propertyId, currentProperty, selectProperty, loading }}>
      {children}
    </PropertyContext.Provider>
  );
}

export const useProperty = () => useContext(PropertyContext);
